export const CheckMarkIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="20" height="20" rx="10" fill="#306FD1" />
    <path d="M5.5 10.3409L7.59086 13.0179C8.09297 13.6607 8.90703 13.6607 9.40914 13.0179L14.5 6.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
)
